"use client";

import { useBreakPoints } from "@/hooks/styles/useBreakpoints";
import br from "@/styles/breakpoints.module.css";
import { Organization, UserDetails } from "@knowt/syncing/graphql/schema";
import { canShowAds } from "@knowt/syncing/hooks/user/subscriptions";
import { useCurrentUser } from "@knowt/syncing/hooks/user/useCurrentUser";
import { SIDEBAR_ADS_CONTAINER_ID } from "../constants";
import { EmptyTrackingDiv, SidebarAdSlot } from "./FreestarAdSlot";
import SlidingVideoAd from "./SlidingVideoAd";

// TODO: maybe refactor this to take in LocalUser object instead
const MainContainerAdSlot = ({
    user,
    organization,
    isEnabled = true,
    lowerVideoAd = false,
    showUntilMd = true,
    customMd = 950,
}: {
    user: UserDetails | null | undefined;
    organization: Organization | null | undefined;
    isEnabled?: boolean;
    lowerVideoAd?: boolean;
    showUntilMd?: boolean;
    customMd?: number;
}) => {
    const { smDown, mdDown } = useBreakPoints({
        md: customMd,
    });

    const adsAllowed = canShowAds({ user, organization });

    if (!adsAllowed) {
        return <EmptyTrackingDiv />;
    }

    if (smDown) return <EmptyTrackingDiv />;

    if (!isEnabled) return <EmptyTrackingDiv />;

    if (mdDown) {
        if (showUntilMd) {
            return <SlidingVideoAd />;
        }

        return <EmptyTrackingDiv />;
    }

    return (
        <div
            id={SIDEBAR_ADS_CONTAINER_ID}
            className={br.mdDownDisplayNone}
            style={{
                alignSelf: "flex-start",
                position: "sticky",
                top: `var(--navbar-height)`,
                width: 320,
                height: 580,
            }}
            data-testid="auto-id-d5c3fa33-5788-4f73-b1cb-25f62922c009">
            <SidebarAdSlot />
            <SlidingVideoAd lower={lowerVideoAd} />
        </div>
    );
};

/**
 * This can be used if the user is not available at render time.
 */
export const FallbackMainContainerAdSlot = ({
    isEnabled = true,
    lowerVideoAd = false,
    showUntilMd = true,
}: {
    isEnabled?: boolean;
    lowerVideoAd?: boolean;
    showUntilMd?: boolean;
}) => {
    const { user, organization, isSubscriptionActive, isUnder13 } = useCurrentUser();

    if (!isEnabled) return <EmptyTrackingDiv />;

    if (isUnder13 || isSubscriptionActive) return <EmptyTrackingDiv />;

    return (
        <MainContainerAdSlot
            user={user}
            organization={organization}
            lowerVideoAd={lowerVideoAd}
            showUntilMd={showUntilMd}
        />
    );
};

export default MainContainerAdSlot;
